export default __webpack_public_path__ + "static/media/38.cea16e2c.png";